import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../../store/modules/user/actions";
import { withFirebase } from "../../services/firebase";

const SignOut = (props) => {
  const navigate = useNavigate();
  const handleSignOut = () => {
    const { firebase, removeUser } = props;

    firebase
      .signOut()
      .then(() => navigate("/"))
      .then(() => {
        removeUser();
        localStorage.removeItem("token");
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <button onClick={handleSignOut}>
      <i className="fa fa-sign-out"></i>
      Logout
    </button>
  );
};

export default compose(connect(null, { removeUser }), withFirebase)(SignOut);
